import React from 'react';
import {
    TextField,
} from 'react-admin';
import CustomTableShow from './CustomTableShow';


class LuckyDrawEventShow extends CustomTableShow {

    customHandled(fields, fieldName, fieldList) {
        if (fieldName === 'promotionPagePath') {
            fieldList.push(<TextField label={'Last page redirection'} source={fieldName} />);
            return true;
        } else if (fieldName === 'winnersCount') {
            fieldList.push(<TextField label={'Winners limit'} source={fieldName} />);
            return true;
        }
        return false;
    }
}

export default LuckyDrawEventShow;